import { BasePageContent } from "../../../../core/content/base-page-content.component";

export class PagecontentSearchCriteriaUSTCRPage extends BasePageContent {
  getPageSpecificText() {
    this.PAGE_TEXT["searchcriteria"] = {
      header: `This search tool provides information on leaking UST cases, such as status, reported date, and closure date.`,
      subtext: `For more information, please contact the ADEQ records center at 602-771-4380 or go to`,
      subtext_1: `Provide any of the following search information and click SEARCH.`,
      lbl_no_result: `Based on the search criteria provided, there are no search results. Please refine your search.`,
      dwnld: `DOWNLOAD LIST OF ALL LEAKING UST CASES`,
      lbl_note: `For more information, please contact the ADEQ records center at 602-771-4380 or go to`,
      lbl_case: `Leaking UST Case#`,
      lbl_fac: `Facility ID#`,
      lbl_company: `Company Name`,
      lbl_fac_nm: `Facility Name`,
      lbl_county: `Facility County`,
      lbl_address: `Facility Address`,
      lbl_confirm_dt: "Confirmation Date",
      lbl_status: `Status`,
      lbl_act: "Action",
      lbl_search: `SEARCH`,
      lbl_search_all: `VIEW ALL`,
      return_btn: "RETURN TO ADEQ WEBSITE",
      lbl_download: "DOWNLOAD LIST OF ALL LEAKING UST CASES",
      searchableFields: [
        {
          id: "facilityIdChk",
          col_name: "Facility ID",
          col_id: "UST_FACILITY_ID",
        },
        {
          id: "facilityNameChk",
          col_name: "Facility Name",
          col_id: "FACILITY_NAME",
        },
        { id: "lustChk", col_name: "Leaking UST#", col_id: "LUST_NUM" },
        {
          id: "facilityLocChk",
          col_name: "Facility Address",
          col_id: "ADDRESS",
        },
        { id: "facilitycounty", col_name: "Facility County", col_id: "COUNTY" },
      ],
    };
  }
}
